<template>
  <div style="margin: 10px 0px 0px 10px;" @mouseleave="focusItem=null">
    <v-toolbar flat dark color="info" @mouseover="focusItem=null">
      <v-dialog max-width="500px" v-model="dialog" persistent>
        <template v-slot:activator="{ on }">
          <label><strong>{{ $t('lang.material.materialType') }}</strong></label>
          <v-btn color="default" v-on="on" icon style="position: absolute; right: 10px; top: 8px;"
                 v-if="showCreateButton">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 0px">
              {{ formTitle }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                      :data-vv-as="$t('lang.material.materialType')"
                      :error-messages="errors.first('categoryName')"
                      :label="$t('lang.material.materialType')"
                      maxLength="250"
                      name="categoryName"
                      type="text"
                      v-model.trim="editedItem.categoryName"
                      v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                      type="text"
                      :label="$t('Ký hiệu vật tư')"
                      v-model.trim="editedItem.parentName"
                      name="parentName"
                      v-validate="'required'"
                      :error-messages="errors.first('parentName')"
                      :data-vv-as="$t('Ký hiệu vật tư')"
                      @keyup="uppercase"
                      :disabled="editedItem.categoryId != null? true: false"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                      :items="materialTypeAllys"
                      :label="$t('Nhóm của loại vật tư')"
                      v-model="editedItem.parentId"
                      name="parentId"
                      item-value="categoryId"
                      item-text="categoryName"
                      :data-vv-as="$t('Nhóm của loại vật tư')"
                      :error-messages="errors.first('parentId')"
                      clearable
                  />
                </v-flex>
                <v-flex xs12>
                    <v-checkbox
                        v-model="editedItem.description"
                        label="Tài sản cố định"
                    ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="onSave" color="primary">
              <v-icon dark left>save</v-icon>
              {{ $t("lang.common.save") }}
            </v-btn>
            <v-btn @click="onCancel" color="error">
              <v-icon dark left>cancel</v-icon>
              {{ $t("lang.common.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1 gru-table fixed-header"
        hide-actions
    >
      <template v-slot:headers="">
        <td style="padding-top: 10px;padding-bottom: 10px;" @mouseover="focusItem=-1">
          <a
              @click="onView({ categoryId: 0 })"
              href="javascript:window.location"
              style="text-decoration: none;"
              :class="getClass(0,{ categoryId: 0 })"
          >
            Tất cả
          </a>
        </td>
      </template>
      <template v-slot:items="props">
        <td @mouseover="focusItem=props.index">
          <a
              @click="onView(props.item)"
              href="javascript:window.location"
              style="text-decoration: none;"
              :class="getClass(props.index+1, props.item)"
          >
            {{ props.item.categoryName }}
          </a>
          <div style="float: right" v-if="props.index == focusItem">
            <v-icon icon color="primary" @click="editItem(props.item)" class="mr-2">
              edit
            </v-icon>
            <v-icon icon color="red" @click="deleteConfirm(props.item)">
              delete
            </v-icon>
          </div>
        </td>

      </template>
    </v-data-table>
  </div>
</template>

<script>
import {message} from "../../../../services";
import axios from "axios";
import {areaContants, roleConstants} from "@/constants";

export default {
  name: "MaterialTypeList",
  props: {
    defaultData: {
      type: Array,
      default: () => [],
    },
    productType: {
      type: String,
      default: null
    }
  },
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "Tên",
        align: "left",
        value: "name",
      },
    ],
    focusItem: null,
    activeItem: {categoryId: 0},
    desserts: [],
    editedIndex: -1,
    editedItem: {
      categoryName: "",
      parentName: "",
      categoryCode: "",
      parentId: null,
      status: 1,
      description: '',
    },
    defaultItem: {
      categoryName: "",
      parentName: "",
      parentId: null,
      status: 1,
      description: '',
    },
    materialTypeAllys: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Thêm mới" : "Cập nhật";
    },
    showCreateButton() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ADMIN) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.onCancel();
    },
    defaultData: function (value) {
      this.desserts = this.copyValue(value);
    },
  },

  created() {
    let url = process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE_ALLY"
    axios.post(url).then((data) => {
          if (data.length > 0) {
            this.materialTypeAllys = data;
          }
        }
    );
  },

  methods: {
    getClass(index, item) {
      if (item != null && this.activeItem != null && item.categoryId == this.activeItem.categoryId) {
        return "activeItem";
      }
      if (this.focusItem == null) {
        return "";
      }
      if (this.focusItem + 1 == index) {
        return "activeItem";
      } else {
        return "";
      }
    },

    copyValue: function (value) {
      let ob = value.slice();
      return ob;
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      console.log(item);
      this.editedItem = {
        categoryId: item.categoryId,
        categoryName: item.categoryName,
        categoryCode: item.categoryCode,
        parentName: item.parentName,
        parentId: item.parentId,
        status: item.status,
        description: item.description,
      };
      this.dialog = true;
    },

    deleteConfirm(item) {
      confirm("Bạn có muốn xóa nhóm vật tư này?") &&
      axios.post(
          process.env.VUE_APP_API_URL + "/material/search?pageSize=10&page=1", {typeId: item.categoryId}
      )
          .then(
              (data) => {
                if (data.items && data.items.length > 0) {
                  message.error("Nhóm vật tư này đã sử dụng, không được xóa!");
                } else {
                  this.deleteItem(item);
                }
              }
          );
    },
    deleteItem(item) {
      axios.post(process.env.VUE_APP_API_URL + "/category/delete?categoryTypeCode=MATERIAL_TYPE", item)
          .then(
              (data) => {
                if (data) {
                  message.success("Đã xóa");
                  this.$emit("getMaterialType");
                  this.close();
                } else {
                  message.error("Lỗi!");
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },

    onCancel() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    onSave() {
      console.log(this.editedItem);
      this.editedItem.categoryCode = this.productType;
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        if (this.editedItem.description) {
            this.editedItem.description = 1;
        } else {
            this.editedItem.description = '';
        }

        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/category/save?categoryTypeCode=MATERIAL_TYPE",
                this.editedItem
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.onCancel();
                    this.$emit("getMaterialType");
                  } else {
                    let msg = '';
                    if (data.description === 'lang.category.duplicateName') {
                      msg = 'Trùng tên nhóm vật tư';
                    } else if (data.description === 'lang.category.duplicateParentName') {
                      msg = 'Trùng ký hiệu nhóm vật tư';
                    } else if (data.description === 'lang.category.duplicateCode') {
                      msg = 'Trùng ký hiệu nhóm vật tư';
                    }
                    message.error(this.$t(msg));
                    // message.error(this.$t(data.description));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },
    onView(item) {
      this.$emit("onView", item);
      this.activeItem = item;
    },
    uppercase() {
      this.editedItem.parentName = this.editedItem.parentName.toUpperCase();
    },
  },
};
</script>